import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from '@/app.component';
import { appConfig } from '@/app.config';
import { environment } from '@environments/environment';
import { loadAppConfig } from '@environments/load-app-config';

loadAppConfig()
  .then(() => {
    if (environment.production) {
      enableProdMode();
    }

    return bootstrapApplication(AppComponent, appConfig);
  })
  .catch((err) => console.error(err));
